
































































import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { MedicationInstructionPayload } from '@/api/medicationInstruction/types'
import InputGroup from '@/mixins/form/inputGroup'

@Component({
  components: {
    TextInput: () => import('@/components/common/inputs/TextInput.vue'),
    PhoneNumberInputGroup: () =>
      import('@/components/common/inputs/inputGroups/PhoneNumberInputGroup.vue')
  }
})
export default class CaremanInputGroup extends mixins(InputGroup) {
  @Prop(Object) inputs!: MedicationInstructionPayload
}
